import { CaseAudit, CaseDetails } from "@/types"
import api from "./api"

/**
 * Manages the audit history of a Case
 */
export default class CaseAuditHistoryService {
	private currentCaseId: string | null = null
	private _auditHistory: CaseAudit[] | null = null

	private refreshing = false
	private refreshQueued = false
	private refreshTimeout: NodeJS.Timeout | null = null

	public get auditHistory (): CaseAudit[] | null {
		return this._auditHistory
	}

	public async load (currentCase: CaseDetails) {
		this.currentCaseId = currentCase?.id ?? null
		await this.refresh()
	}

	public async refresh () {
		if (!this.currentCaseId) {
			this.clear()
			return
		}

		if (this.refreshing) {
			this.refreshQueued = true
			return
		}

		this.refreshing = true

		if (this.auditHistory && this.auditHistory.length > 0) {
			const lastAudit = this.auditHistory[0].changedAt
			const newEntries = await api.history(this.currentCaseId!, lastAudit)
			this._auditHistory = newEntries.concat(this.auditHistory)
		} else {
			this._auditHistory = await api.history(this.currentCaseId!)
		}

		this.refreshing = false

		if (this.refreshQueued) {
			this.refreshQueued = false
			if (!this.refreshTimeout) {
				this.refreshTimeout = setTimeout(() => {
					this.refreshTimeout = null
					this.refresh()
				}, 10)
			}
		}
	}

	public async clear () {
		this._auditHistory = null
		this.currentCaseId = null
		if (this.refreshing) {
			await this.refresh()
		}
		this.refreshing = false
		this.refreshQueued = false
		if (this.refreshTimeout) {
			clearTimeout(this.refreshTimeout)
			this.refreshTimeout = null
		}
	}
}
